import { useEffect, useState } from "react";
import {
  occupations,
  relations,
  sourceofIncome,
} from "../../api/fundsCalculatorApi";

export const Step2Form = ({ formData, handleInputChange, disabled }) => {
  const [incomeSource, setIncomeSource] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [relation, setRelation] = useState([]);

  const fetchSourceOfIncome = async () => {
    try {
      const response = await sourceofIncome();
      setIncomeSource(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };
  const fetchOccupations = async () => {
    try {
      const response = await occupations();
      setOccupation(response.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRelations = async () => {
    try {
      const response = await relations();
      setRelation(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchSourceOfIncome();
    fetchOccupations();
    fetchRelations();
  }, []);

  return (
    <div className="grid grid-cols-3 gap-6 mb-6">
      {/* Relationship with Applicant */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Relationship with Applicant <span className="text-red-500">*</span>
        </label>
        <select
          value={formData.relationship}
          onChange={(e) => handleInputChange("relationship", e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        >
          <option value="">Select Relation</option>
          {relation.map((item) => (
            <option key={item.id} value={item.id}>
              {item.relations}
            </option>
          ))}
        </select>
      </div>

      {/* Name of the Sponsor */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Name of the Sponsor <span className="text-red-500">*</span>
        </label>

        <input
          disabled={disabled}
          placeholder="Enter Name of Sponsor"
          type="text"
          value={formData.sponsorName || ""}
          onChange={(e) => {
            const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
            handleInputChange("sponsorName", value);
          }}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        />
      </div>

      {/* Occupation of Sponsor */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Occupation of Sponsor <span className="text-red-500">*</span>
        </label>
        <select
          disabled={disabled}
          value={formData.occupation}
          onChange={(e) => handleInputChange("occupation", e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        >
          <option value="">Select Occupation</option>
          {occupation.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      {/* Source of Income */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-2">
          Source of Income <span className="text-red-500">*</span>
        </label>
        <select
          disabled={disabled}
          value={formData.sourceOfIncome}
          onChange={(e) => handleInputChange("sourceOfIncome", e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#572575] focus:border-transparent"
        >
          <option>Select Source of income</option>
          {incomeSource.map((item) => (
            <option key={item.id} value={item.id}>
              {item.source_of_income}
            </option>
          ))}
        </select>
      </div>

      {/* Have they filled ITR */}
      <div>
        <label className="block text-black text-[16px] font-altis mb-4">
          Have they filled ITR for last 2 years?{" "}
          <span className="text-red-500">*</span>
        </label>
        <div className="flex space-x-6">
          <label className="flex items-center cursor-pointer">
            <input
              disabled={disabled}
              type="radio"
              name="filledItr"
              value={1}
              checked={formData.filledItr == 1}
              onChange={(e) => handleInputChange("filledItr", e.target.value)}
              className="w-4 h-4 border-[#9b228e] accent-[#9b228e] focus:ring-0"
            />
            <span className="ml-2 text-black text-[16px]">Yes</span>
          </label>

          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="filledItr"
              value={0}
              checked={formData.filledItr == 0}
              onChange={(e) => handleInputChange("filledItr", e.target.value)}
              className="w-4 h-4 border-gray-400 accent-[#9b228e] focus:ring-0"
            />
            <span className="ml-2 text-black text-[16px]">No</span>
          </label>
        </div>
      </div>
    </div>
  );
};
